'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _validator = require('validator');

var _isPostalCode = require('./isPostalCode');

var isValid = function isValid(_ref) {
	var value = _ref.value,
	    criteria = _ref.criteria,
	    min = _ref.min,
	    max = _ref.max,
	    required = _ref.required,
	    regex = _ref.regex;

	var isEmpty = value === null || value === undefined || value === '';

	if (required && isEmpty) {
		return false;
	} else if (!required && isEmpty) {
		return true;
	}

	var valueToValidate = String(value);

	if (!(0, _validator.isLength)(valueToValidate, { min: min, max: max })) {
		return false;
	}

	if (regex && valueToValidate.match(regex) === null) {
		return false;
	}

	switch (criteria) {
		case 'email':
			return (0, _validator.isEmail)(valueToValidate);

		case 'credit card':
			return (0, _validator.isCreditCard)(valueToValidate);

		case 'FQDN':
			return (0, _validator.isFQDN)(valueToValidate);

		case 'url':
			return (0, _validator.isURL)(valueToValidate);

		case 'zip':
			return (0, _isPostalCode.isZip)(valueToValidate);

		case 'canadian postal code':
			return (0, _isPostalCode.isCanadianPostalCode)(valueToValidate);

		default:
			return true;
	}
};

exports.default = isValid;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMValidatingTextField/isValid.js